import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import moment from 'moment/moment'
import { FiEye } from 'react-icons/fi'
import { Link} from 'react-router-dom'

const columns = [
  {
    name: 'Name',
    selector: (row) => (
    <Link to={`task/view/${row._id}`} className="hover:underline">
      {row.name}
    </Link>
    )
  },
  {
    name: 'Company',
    selector: (row) => row.company,
  },
  {
    name: 'Assign To',
    selector: (row) => row.assignTo,
  },
  {
    name: 'Added Date',
    selector: (row) => moment(row.createdAt).format('DD/MM/YYYY hh:mm A'),
  },
  {
    name: 'Due Date',
    selector: (row) => moment(row.dueDate).format('DD/MM/YYYY hh:mm A'),
  },
  {
    name: 'Final Submitted Date',
    selector: (row) => moment(row.completionDate).format('DD/MM/YYYY hh:mm A'),
  },
  {
    name: 'Actions',
    cell: (row) => (
      <div className='flex items-center'>
        <Link to={`task/view/${row._id}`}>
          <div className='w-8 h-8 flex items-center justify-center rounded-full hover:bg-primary cursor-pointer hover:text-white text-primary'>
            <FiEye className='w-4 h-4' />
          </div>
        </Link>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
]

const FinalSubmitTask = () => {
  const [data, setData] = useState([])
  const [pages, setPages] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalRows, setTotalRows] = useState(0)


  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get('task/list', {
        page: pages,
        limit: limit,
        isSubmit: true,
      })
      if (response && response.status === 200) {
        const transformedData = response.data.result.docs
        setData(transformedData)
        setTotalRows(response.data.result.totalDocs)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [pages, limit])

  const handlePageChange = (newPage) => {
    setPages(newPage)
  }

  const handleLimitPerPageChange = (newLimit) => {
    setLimit(newLimit)
    setPages(1)
  }

  return (
    <>
      <h2 className='text-xl font-semibold mb-4 flex items-center gap-2'>
        Final Submit
      </h2>
      <DataTable
        columns={columns}
        data={data}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[10, 20, 30]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitPerPageChange}
      />
    </>
  )
}

export default FinalSubmitTask
